export const SET_VIEW = "SET_VIEW";

interface ActionTypes {
  SET_VIEW: string;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export function setCurrentView(
  currentView: string,
  usedSwitcher: boolean
): CurrentMapViewTypes {
  return {
    type: SET_VIEW,
    payload: { currentView, usedSwitcher },
  };
}

export type CurrentMapViewTypes = MessageAction;
